import { EtfBreadcrumb } from "@/components/layout/EtfBreadcrumb";
import type { FundDetail } from "@/data/fund-detail-types";
import { categoryListingPath } from "@/lib/fund-paths";

export function FundBreadcrumb({ fund }: { fund: FundDetail }) {
  const isBuffer = fund.type === "buffer";

  const typeLabel = isBuffer
    ? "Buffer ETFs"
    : fund.type === "thematic"
      ? "Thematic ETFs"
      : fund.type === "fixed"
        ? "Fixed Income ETFs"
        : fund.leveragedSubtype === "single-stock"
          ? "Single-Stock 2x ETFs"
          : "2x Leveraged ETFs";

  const typeHref = categoryListingPath(fund.type);

  const family = isBuffer
    ? fund.categoryLabel.replace(/^Structured Buffer ETF\s*[\u00B7\u2022]\s*/i, "").trim()
    : "";
  const fundLabel =
    isBuffer && fund.bufferLevel && fund.seriesMonth
      ? `${family} ${fund.bufferLevel.toFixed(2)}% Buffer \u2014 ${fund.seriesMonth}`
      : fund.ticker;

  return (
    <EtfBreadcrumb
      className="tracking-[0.06em] py-4"
      items={[
        { label: "Home", href: "/" },
        { label: "Products", href: "/products" },
        { label: typeLabel, href: typeHref },
        { label: fundLabel },
      ]}
    />
  );
}
